import { EnumDesfechoOcorrencia } from '@core/models/enums';

export interface EncerrarOcorrenciaFormValue {
  desfecho: number | null;
  acoesTomadas: string;
  dataResolucao: Date | string | null;
  entidadesAccionadas?: string | null;
  valorDanosPerdas?: number | null;
  descricaoDanosPerdas?: string | null;
}

export interface ResolucaoOcorrencia {
  desfecho?: number | null;
  desfechoDescricao?: string | null;
  acoesTomadas?: string | null;
  dataResolucao?: string | null;
  resolvidoPor?: string | null;
  resolvidoPorId?: number | null;
  entidadesAccionadas?: string | null;
  valorDanosPerdas?: number | null;
  descricaoDanosPerdas?: string | null;
  tempoAteResolucaoMinutos?: number | null;
}

export const OPCOES_DESFECHO_FALLBACK = [
  { label: 'Resolvida', value: EnumDesfechoOcorrencia.RESOLVIDA },
  { label: 'Falso alarme', value: EnumDesfechoOcorrencia.FALSO_ALARME },
  { label: 'Sem acção necessária', value: EnumDesfechoOcorrencia.SEM_ACCAO_NECESSARIA },
  { label: 'Encaminhada às autoridades', value: EnumDesfechoOcorrencia.ENCAMINHADA_AUTORIDADES },
];
